// extracted by mini-css-extract-plugin
export default {"nativeview":"b95fd2198472a4ee8410"};